import type { IconProps } from '@launchpad-ui/icons';
import { Icon } from '@launchpad-ui/icons';

export function DataDogLogoIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <use href="#app-icon-data-dog-logo" />
    </Icon>
  );
}
